import { RootState } from '@store';

export const selectPCodeMasterList = (state: RootState) => {
  return state.pCodeMasterList?.pCodeMasterList;
};

export const selectPCodeMasterData = (state: RootState) => {
  return state.pCodeMasterList?.pCodeMasterData;
};
